<!-- 检索结果 -->
<template>
  <div class="frame search-page">
    <div class="search-hero">
      <h1 class="search-hero-title">{{ $t("search.title") }}</h1>
      <form class="search-hero-form" @submit.prevent="onSearch">
        <input
          v-model="keyword"
          type="search"
          class="search-hero-input"
          :placeholder="$t('search.placeholder')"
        />
        <button type="submit" class="search-hero-btn">
          <i class="el-icon-search"></i>
        </button>
      </form>
      <p class="search-meta" v-if="query">
        {{ $t("search.resultCount", { count: results.length, q: query }) }}
      </p>
    </div>

    <div class="search-body">
      <div v-if="!query" class="search-empty">
        {{ $t("search.enterKeyword") }}
      </div>
      <div v-else-if="results.length === 0" class="search-empty">
        {{ $t("search.noResults") }}
      </div>
      <ul v-else class="result-list">
        <li v-for="(item, index) in results" :key="index" class="result-item">
          <span class="result-type">{{ typeLabel(item.type) }}</span>
          <router-link :to="item.path" class="result-link" @click.native="scrollTop">
            <h3 class="result-title">{{ item.title }}</h3>
            <p class="result-snippet" v-if="item.text">{{ item.text }}</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { searchSite } from "@/utils/siteSearch";

export default {
  name: "SearchPage",
  data() {
    return {
      keyword: "",
      results: [],
    };
  },
  computed: {
    query() {
      return (this.$route.query.q || "").trim();
    },
  },
  watch: {
    "$route.query.q": {
      immediate: true,
      handler(val) {
        this.keyword = val || "";
        this.runSearch();
      },
    },
    "$i18n.locale"() {
      this.runSearch();
    },
  },
  methods: {
    typeLabel(type) {
      const key = `search.types.${type}`;
      const t = this.$t(key);
      return t === key ? type : t;
    },
    runSearch() {
      this.results = searchSite(this.query, this.$i18n);
    },
    onSearch() {
      const q = this.keyword.trim();
      if (!q) return;
      if (this.$route.query.q === q) {
        this.runSearch();
        return;
      }
      this.$router.push({ path: "/search", query: { q } });
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-page {
  background-color: $box-bg;
  min-height: calc(100vh - 180px);
}

.search-hero {
  padding: 48px 40px 32px;
  background-color: #fff;
  border-bottom: 1px solid #e8eef5;
}

.search-hero-title {
  margin: 0 0 20px;
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
}

.search-hero-form {
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  align-items: stretch;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.search-hero-input {
  flex: 1;
  min-width: 0;
  padding: 12px 16px;
  font-size: 15px;
  border: 1px solid #e0e8f0;
  border-right: none;
  border-radius: 6px 0 0 6px;
  outline: none;

  &:focus {
    border-color: #fdc44b;
  }
}

.search-hero-btn {
  flex-shrink: 0;
  width: 52px;
  border: none;
  background: linear-gradient(145deg, #ffc04d 0%, #ff8c00 48%, #f07800 100%);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  border-radius: 0 6px 6px 0;

  &:hover {
    opacity: 0.92;
  }
}

.search-meta {
  margin: 16px 0 0;
  text-align: center;
  font-size: 14px;
  color: #888;
}

.search-body {
  width: 1200px;
  max-width: calc(100% - 80px);
  margin: 0 auto;
  padding: 40px 0 80px;
}

.search-empty {
  text-align: center;
  padding: 60px 20px;
  font-size: 15px;
  color: #888;
}

.result-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.result-item {
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.25s;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
}

.result-type {
  display: inline-block;
  margin-bottom: 8px;
  padding: 2px 10px;
  font-size: 12px;
  color: #f18000;
  background: rgba(253, 196, 75, 0.2);
  border-radius: 999px;
}

.result-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.result-title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;

  &:hover {
    color: #f18000;
  }
}

.result-snippet {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
